import {useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import {Form} from "react-bootstrap";
import {axiosInstance} from "../../../components/helpers/axiosInstance";
import MiembrosMap from "../../../components/helpers/MiembrosMap";
import TitleTooltip from "../../../components/helpers/TitleTooltip";

/**
 *
 * @param task
 * @param idTask
 * @returns {JSX.Element}
 * @constructor
 */

// todo : id, data, url - nuevos props del componente para hacerlo general
export default function Comentarios({
    task,
    idTask,
}){

    // arreglo original de respuestas
    const [comentarios, setComentarios] = useState([]);
    // bandera para habilitar respuesta
    const [addResponse, setAddResponse] = useState(null);
    // datos de usuario
    const auth = JSON.parse(sessionStorage.getItem("user"));
    // nuevo comentario
    const [uComent, setUComent] = useState(null);
    //
    const [editC, setEditC] = useState(null);
    const [cerrar, setCerrar] = useState(null);
    const [endScroll, setEndScroll] = useState(false);

    dayjs.extend(relativeTime);

    useEffect(() => {
        setComentarios(task.comentarios);
    }, [task]);

    useEffect(() => {
        const comentariosV = [];
        task.comentarios && task.comentarios.length > 0 && task.comentarios.forEach((c) => {
            if (!c.vistas.some((n) => n.id_usuario === auth.usuario.id_usuario)) {
                comentariosV.push({
                    id_comentario: c.id_comentario,
                    id_usuario: auth.usuario.id_usuario
                });
            }

            c.respuestas && c.respuestas.length > 0 && c.respuestas.forEach((r) => {
                if (!r.vistas.some((n) => n.id_usuario === auth.usuario.id_usuario)) {
                    comentariosV.push({
                        id_comentario: r.id_comentario,
                        id_usuario: auth.usuario.id_usuario
                    });
                }
            })
        })
        const peticion = () => {
            axiosInstance.post('/todo/vistas/', comentariosV)
                .then((res) => {
                    if (res.status === 200) {
                        setEndScroll(true);
                        comentariosV.splice(0, comentariosV.length);
                    }
                }).catch((err) => console.error(err))
        }

        setTimeout(() => {
            if ((document.body.scrollHeight === window.innerHeight) && comentariosV.length > 0){
                peticion();
            } else {
                window.onscroll = function(ev) {
                    if (((window.innerHeight + window.scrollY) >= document.body.scrollHeight) && comentariosV.length > 0) {
                        peticion();
                    }
                };
            }
        },[1000]);

    }, [task, idTask, auth.usuario.id_usuario]);

    function deleteComent(id, idpadre){
        axiosInstance.delete('/todo/comentarios/', {data: {
                id_comentario: id
            }}).then((res) => {
            if (res.data.result === "Comentario eliminado correctamente"){
                if (idpadre){
                    setComentarios(
                        comentarios.map(c => {
                            if (c.id_comentario === idpadre){
                                return {
                                    ...c,
                                    respuestas: c.respuestas.filter(cm => cm.id_comentario !== id)
                                };
                            } else {
                                return c;
                            }
                        })
                    )
                } else {
                    setComentarios(comentarios.filter(cm => cm.id_comentario !== id));
                }
            }
        }).catch((err) => console.error(err));
    }

    function updateComent(id){
        axiosInstance.put('/todo/comentarios/',{
            id_comentario: id,
            comentario: uComent,
        }).then((res) => res.status === 200 && setEditC(null))
            .catch((err) => console.error(err));
    }
    function closeComent(id){
        setAddResponse(id);
        axiosInstance.put('/todo/comentarios/', {
            id_comentario: id,
            cerrado: true
        }).then((res) => {
            if (res.data.result === "Comentario actualizado correctamente"){
                //console.log(cerrar);
                setCerrar(id);
            }
        })
            .catch((err) => console.error(err));
    }

    return(
        <div className={"mt-3"}>
            <style type={'text/css'}>
                {`
                    .nuevo-comentario{
                        border: 1px, solid, #F6C000;
                        box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0,0,0,.075);
                        border-radius: 1rem;
                    }
                `}
            </style>
            {
                comentarios && comentarios.length > 0 && <div className="">
                    <div className="mb-6">
                        <div className="separator separator-solid mb-1"></div>
                        <div className="shadow-sm p-3 bg-gray-100">
                            {
                                comentarios && comentarios.map((c) => {
                                    const itsNew = c.vistas ? c.vistas.some((n) => n.id_usuario === auth.usuario.id_usuario) : true;
                                    return (
                                        <div key={c.id_comentario} className={"d-block"}>
                                            <div className={"d-flex  pt-3 " + (!itsNew && !endScroll ? "nuevo-comentario" : "")}>
                                                <div className="symbol symbol-45px me-5 symbol-hover">
                                                    <MiembrosMap user={c.usuario.username} avatar={c.usuario.avatar}></MiembrosMap>
                                                </div>
                                                <div className="d-flex flex-column flex-row-fluid">
                                                    <div
                                                        className="d-flex align-items-center mb-0">
                                                        <button type={'button'}
                                                            className="btn p-0 text-gray-800 text-hover-primary fw-bold me-6 text-capitalize">{c.usuario.username}
                                                        </button>
                                                        <span className="text-gray-500 fw-semibold fs-7 me-5">{c.creado && dayjs(c.creado).fromNow()}</span>
                                                        <div className={"ms-auto"}>
                                                            {
                                                                ( c.cerrado === 1 || cerrar === c.id_comentario ) ? (<> </>) : (
                                                                    <TitleTooltip title={'Responder comentario'} placement={'top'}>
                                                                        <button
                                                                            type={'button'}
                                                                            className="btn p-0 ms-auto text-gray-500 text-hover-primary fw-semibold fs-7"
                                                                            onClick={() => setAddResponse(c.id_comentario)}>
                                                                            <i className="bi bi-reply"></i>
                                                                        </button>
                                                                    </TitleTooltip>
                                                                    )
                                                            }
                                                            {
                                                                c.usuario.id_usuario === auth.usuario.id_usuario && c.respuestas.length === 0 &&
                                                                <>
                                                                    <TitleTooltip title={'Cerrar'} placement={'top'}>
                                                                        <button
                                                                            type={'button'}
                                                                            className={"btn p-0 ms-auto text-gray-500 text-hover-primary fw-semibold fs-7"}
                                                                            onClick={() => closeComent(c.id_comentario)}>
                                                                            <i className="bi bi-lock-fill"></i>
                                                                        </button>
                                                                    </TitleTooltip>
                                                                    <TitleTooltip title={'Eliminar'} placement={'top'}>
                                                                        <button
                                                                            type={'button'}
                                                                            className="btn p-0 ms-auto text-gray-500 text-hover-primary fw-semibold fs-7"
                                                                            onClick={() => deleteComent(c.id_comentario, null)}>
                                                                            <i
                                                                                className="bi bi-trash3"></i>
                                                                        </button>
                                                                    </TitleTooltip>
                                                                    <TitleTooltip title={'Editar'} placement={'top'}>
                                                                        <button
                                                                            type={'button'}
                                                                            className="btn p-0 ms-auto text-gray-500 text-hover-primary fw-semibold fs-7"
                                                                            onClick={() => setEditC(c.id_comentario)}>
                                                                            <i className="bi bi-pencil-fill"></i>
                                                                        </button>
                                                                    </TitleTooltip>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={"d-flex align-items-center"}>
                                                        <Form.Control
                                                            disabled={c.id_comentario !== editC }
                                                            plaintext={c.id_comentario !== editC}
                                                            id={`${c.id_comentario}`}
                                                            className="text-capitalize text-gray-800 fs-7 fw-normal w-100"
                                                            defaultValue={c.comentario}
                                                            onChange={(event) => setUComent(event.target.value)}
                                                        />
                                                        {
                                                            editC === c.id_comentario &&
                                                            <button className={"btn p-0 ms-1"} type={'button'}
                                                                    onClick={() => updateComent(c.id_comentario)}>
                                                                <i className="bi bi-send fs-3"></i></button>
                                                        }
                                                    </div>
                                                    <div className={"separator my-2"}></div>
                                                </div>
                                            </div>
                                            {
                                                c.respuestas && c.respuestas.length > 0 && c.respuestas.map((r) => {
                                                    const itsNewR = r.vistas ? r.vistas.some((n) => n.id_usuario === auth.usuario.id_usuario) : true;
                                                    return (
                                                        <div key={r.id_comentario} className={"d-flex pt-3 ms-10 " + (!itsNewR && !endScroll ? "nuevo-comentario" : "")}>
                                                            <div className="symbol symbol-45px me-5 symbol-hover">
                                                                <MiembrosMap user={r.usuario.username} avatar={r.usuario.avatar}></MiembrosMap>
                                                            </div>
                                                            <div
                                                                className="d-flex flex-column flex-row-fluid">
                                                                <div
                                                                    className="d-flex align-items-center mb-0">
                                                                    <button type={'button'}
                                                                        className="btn p-0 text-gray-800 text-hover-primary fw-bold me-6 text-capitalize">{r.usuario.username}
                                                                    </button>
                                                                    <span
                                                                        className="text-gray-500 fw-semibold fs-7 me-5">{r.creado && dayjs(r.creado.slice(0, 10)).fromNow()}</span>
                                                                    <div className={'ms-auto'}>
                                                                        {
                                                                            r.usuario.id_usuario === auth.usuario.id_usuario &&
                                                                            <>
                                                                                <TitleTooltip title={'Eliminar'} placement={'top'}>
                                                                                    <button
                                                                                        type={'button'}
                                                                                        className="btn p-0 ms-auto text-gray-500 text-hover-primary fw-semibold fs-7"
                                                                                        onClick={() => deleteComent(r.id_comentario, c.id_comentario)}>
                                                                                        <i
                                                                                            className="bi bi-trash3"></i>
                                                                                    </button>
                                                                                </TitleTooltip>
                                                                                <TitleTooltip title={"Editar"} placement={'top'}>
                                                                                    <button
                                                                                        type={'button'}
                                                                                        onClick={() => setEditC(r.id_comentario)}
                                                                                        className="btn p-0 ms-auto text-gray-500 text-hover-primary fw-semibold fs-7">
                                                                                        <i className="bi bi-pencil-fill"></i>
                                                                                    </button>
                                                                                </TitleTooltip>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"d-flex align-items-center"}>
                                                                    <Form.Control disabled={editC !== r.id_comentario}
                                                                                  plaintext={editC !== r.id_comentario}
                                                                                  className="text-gray-800 fs-7 fw-normal text-capitalize w-100"
                                                                                  defaultValue={r.comentario}
                                                                                  id={`${r.id_comentario}`}
                                                                                  onChange={(event) => setUComent(event.target.value)}
                                                                    />
                                                                    {
                                                                        editC === r.id_comentario &&
                                                                        <button type={"button"} className={"btn p-0 ms-1"}
                                                                                onClick={() => updateComent(r.id_comentario)}>
                                                                            <i className="bi bi-send fs-3"></i>
                                                                        </button>
                                                                    }
                                                                </div>
                                                                <div className={"separator my-2"}></div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                            {
                                                addResponse === c.id_comentario &&
                                                <div className={'pt-3 pb-6 ms-10'}>
                                                    <NuevoComentario idTask={idTask} idComentario={c.id_comentario} comentarios={comentarios} setComentarios={setComentarios}></NuevoComentario>
                                                </div>
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>

                </div>
            }
            <NuevoComentario idTask={idTask} idComentario={null} comentarios={comentarios} setComentarios={setComentarios}></NuevoComentario>
        </div>
    );
}

function NuevoComentario({
     idTask,
     idComentario, // idPadre
     comentarios,
     setComentarios,
}){
    const [newComent, setNewComent] = useState("");
    const auth = JSON.parse(sessionStorage.getItem("user"));

    function sentComent(){
        if (newComent.length > 1){
            axiosInstance.post('/todo/comentarios/',
                {
                    id_tarea: idTask,
                    id_usuario: auth.usuario.id_usuario,
                    comentario: newComent,
                    id_comentario: idComentario
                }).then((res) => {
                const nuevoComentario = {
                    id_comentario: res.data.id_comentario,
                    id_parent: null,
                    usuario: {
                        id_usuario: auth.usuario.id_usuario,
                        username: auth.usuario.usuario,
                        avatar: auth.usuario.avatar
                    },
                    comentario: newComent,
                    cerrado: 0,
                    visible: "t",
                    creado: dayjs().format(),
                    respuestas: []
                };

                if (res.data.id_comentario){
                    setNewComent("");
                    // agregar respuesta
                    if (idComentario){
                        setComentarios(
                            comentarios.map((c) => {
                                if (c.id_comentario === idComentario){
                                    return {
                                        ...c,
                                        respuestas : [
                                            ...c.respuestas,
                                            nuevoComentario
                                        ]
                                    };
                                } else {
                                    return c;
                                }
                            })
                        );
                    } else {
                        setComentarios([
                            ...comentarios, nuevoComentario
                        ]);
                    }
                }
            })
                .catch((err) => console.error(err));
        }

    }

    return (
        <>
            <div className="d-flex align-items-center ">
                <div className="symbol symbol-35px me-3">
                    <span className={"symbol-label fw-bold " + auth.usuario.avatar}>
                        {auth.usuario.avatar}
                    </span>
                </div>
                <div className="position-relative w-100">
                <textarea type="text" className="form-control border ps-5 resize-none"
                          rows="1"
                          name="search"
                          value={newComent}
                          placeholder="Nuevo comentario..."
                          onChange={(e) => setNewComent(e.target.value)}
                          onKeyDown={(e) => {
                              if (e.code === "Enter") {
                                  e.preventDefault();
                                  sentComent();
                              }
                          }}
                >
                </textarea>
                </div>
                <button type={'button'} className={"btn p-0 ms-1"} onClick={sentComent}><i className="bi bi-send fs-2"></i></button>
            </div>
        </>
    );
}
